import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-241">
      <div className="max-w-2xl mx-auto text-center" data-id="element-242">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-243">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#F97316] mb-4" data-id="element-244">
          GARANTÍA EDULABS — 7 DÍAS
        </h2>

        <div className="bg-[#1a0800] border-2 border-[#F97316] rounded-2xl p-8 mb-6" data-id="element-245">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-246">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en el entrenamiento
            si querés.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-247">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#F97316] text-3xl font-black mb-4" data-id="element-248">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-249">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-250">
          La confianza que tenemos en el MegaPack Básquet Listo nos permite
          hacer esa promesa sin dudar.
          <br data-id="element-251" />
          Entrenadores de básquet de toda la región de habla hispana ya lo
          saben.
          <br data-id="element-252" />
          La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}